import type { Offer } from "@/api/offerBank";
import type { OffersConfig } from "@/types/dragon-tiles";

const OFFER_TAG_RE = /\{%\s*offer\s+'([^']+)'\s*%\}/g;

export function extractOffersFromText(
  text: string,
  offers: Offer[],
): OffersConfig {
  const config: OffersConfig = {};
  let match: RegExpExecArray | null;
  while ((match = OFFER_TAG_RE.exec(text)) !== null) {
    const slug = match[1];
    if (slug && !config[slug]) {
      const offer = offers.find((o) => o.slug === slug);
      config[slug] = { fallback_code: offer?.static_code ?? slug };
    }
  }
  OFFER_TAG_RE.lastIndex = 0;
  return config;
}

export function mergeOffersConfigs(
  ...sources: (OffersConfig | undefined)[]
): OffersConfig {
  const merged: OffersConfig = {};
  for (const source of sources) {
    if (!source) continue;
    for (const [slug, offer] of Object.entries(source)) {
      if (!merged[slug]) {
        merged[slug] = offer;
      }
    }
  }
  return merged;
}

export function buildPreviewOffersConfig(args: {
  offersList: Offer[];
  savedOffers?: OffersConfig;
  bodyText?: string;
  subjectLine?: string;
  preheader?: string;
}): OffersConfig {
  const {
    offersList,
    savedOffers,
    bodyText = "",
    subjectLine = "",
    preheader = "",
  } = args;

  return mergeOffersConfigs(
    savedOffers,
    extractOffersFromText(bodyText, offersList),
    extractOffersFromText(subjectLine, offersList),
    extractOffersFromText(preheader, offersList),
  );
}
